import React, { Component } from "react";
import { getLocalStorageVariables, getThemeSettingsVariables, handleTokenExpiry, isEmptyArray } from "../../common/Global/commonFunctions";
import * as Constants from '../../common/Global/constants';
import TableDropDown from "../../common/DropdownMenus/TableDropdown";
import AlertDialog from "../../common/AlertDialog";
import Pagination from "../../common/Global/pagination";
import { Modal } from "react-bootstrap";
import FrameworkClauseLinkDialog from "./frameworkClauseLinkDialog";

let themeSettings = getThemeSettingsVariables();
let userDetails = getLocalStorageVariables();
const activeStatus = "active";

class RootFrameworkDialog extends Component {
    constructor (props) {
        super(props);
        this.state = {
            showLoader: false,
            componentDidMountFlag: false,
            currentPageNo: 1,
            resultSize:Constants.RESULT_SIZE_GRID,
            resultSizePlaceholder:Constants.RESULT_SIZE_GRID,
            totalCount:0,
            searchkey: "",
            selectedItem:"",
            status:activeStatus,
            statusPlaceholder:"Active",
            frameworks: [],
            showCreateDialog: false,
            isEdit: false,
            selectedId: "",
            frameworkName: "",
            resultSizeArr: JSON.parse(JSON.stringify(Constants.RESULT_SIZE_GRID_DD_ARR)),
            showLinkDialog:false
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }
    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showFrameworkClauseDialog){
            this.setState({
                showLoader:false,
    
            },()=>{
                this.getFrameworkMasterList();
            })
        }
    }

    onTableDropDownItemClick = (item, dropdownItem) => {
        if(item.label === "Link"){
            this.setState({
                showLinkDialog:true,
                rootFrameworkId:dropdownItem.frameworkId,
                frameworkName:dropdownItem.frameworkName,
            })
        }
    }

    // Method to handle alert dialog close
    handleAlertDialogClose = () => {
        this.setState({
            showAlertDialog: false,
            alertDialogMessage: "",
        });
    }

    // Handle pagination click
    onChangePage = (page) => {
        // update state with new page of items
        if(page !== this.state.currentPageNo){
            this.setState({
                showLoader:true,
            });
            this.getFrameworkMasterList(page);
        }
    }

    // Handle info alert dialog close event
    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        });
    }

    // Handle link dialog close event
    handleLinkDialogClose = (reloadFlag) => {
        this.setState({
            showLinkDialog:false
        },() => {
            if(reloadFlag == true){
                this.props.handleRootFrameworkDialogClose(true);
            }
        })
    }

    /*******************API CALLS*******************/
    getFrameworkMasterList = (page = null) => {
        this.setState({
            showLoader:true,
        });
        // const pageNo = page || this.state.currentPageNo;
        fetch(Constants.GetRootFramework, {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
                // pageNo:pageNo,
                search:this.state.searchkey,
                status:"All", 
                // resultsize:this.state.resultSize,
            })
        })
        .then(res => res.json())
        .then(res => {
            let frameworks = [];
            if(handleTokenExpiry(res.responseCode)) return;
            else if(res.responseCode === Constants.CODE_SUCCESS){
                frameworks = res.data.result.filter(item => item.frameworkId !== this.props.frameworkId1);
            }
            this.setState({
                componentDidMountFlag: true,
                showLoader: false,
                frameworks: frameworks,
                totalCount: res.data?.count ?? 0,
            });
        })
    }

    handleRecordOperation = () => {
        this.setState({
            showLoader:true,
        });

        fetch(Constants.DeleteFramework,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                frameworkId:this.state.deleteFrameworkId
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    showLoader:false,
                    deleteFrameworkId:"",
                    alertDialogHeading:"",
                    proceedBtnLabel:"",
                    alertDialogMessage:"",
                    showAlertDialog:false,
                    actionType:"",
                },() => {
                    this.getFrameworkMasterList();
                });
            }else{
                this.setState({
                    showLoader:false,
                    deleteFrameworkId:"",
                    alertDialogHeading:"",
                    proceedBtnLabel:"",
                    alertDialogMessage:"",
                    actionType:"",
                    showAlertDialog:false,
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                })
            }
        });
    }
    /*******************API CALLS END HERE*******************/

    render () {
        return (
            <>
                <Modal className="show-framework-tree-dialog custom-dialog" show={this.props.showFrameworkClauseDialog} onHide={this.props.handleRootFrameworkDialogClose} backdrop="static">
                    <Modal.Header>
                        <h5>{"Framework"}</h5>
                        <button 
                            onClick={this.props.handleRootFrameworkDialogClose}
                            type="button" data-dismiss="modal">
                            <span className="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        { 
                            this.state.showLoader && 
                            <div class="loader"></div>
                        }
                        <div className="row">
                            {this.state.frameworks.map((item, idx) => {
                                const actionObj = {
                                    actionArr: [
                                        {icon: "link", label: "Link"},
                                    ],
                                    dropdownWidth: "120px",
                                };
                                let marTop = 10;
                                if(idx === 0 || idx === 1 || idx === 2){
                                    marTop=0;
                                }

                                return (
                                    <div className="col-md-4 custom-col-5" key={item.frameworkName}>
                                        <div className="tree-list-card-layout c-pointer"
                                            style={{marginTop:marTop}}>
                                            <div className="tree-card-text-layout">
                                                <p className="font-bold font-bold-resize">{item.frameworkName}</p>
                                            </div>
                                            <div className="action-dd-layout">
                                                <TableDropDown
                                                    actionArr={actionObj.actionArr}
                                                    onDropDownItemClick = {this.onTableDropDownItemClick}
                                                    dropDownId = {item}
                                                    dropdownWidth={actionObj.dropdownWidth}
                                                    themeSettings={themeSettings}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="pagination-layout">
                            <div className="row custom-row">
                                <div className="col-md-9 custom-col">
                                {
                                    (this.state.totalCount > this.state.frameworks.length) && 
                                    <Pagination 
                                        totalLength ={this.state.totalCount} 
                                        items={this.state.frameworks} 
                                        onChangePage={this.onChangePage} 
                                        pageSize={this.state.resultSize}
                                        currentPageNo = {this.state.currentPageNo}
                                        initialPage={this.state.currentPageNo} 
                                        themeSettings={themeSettings}/>
                                }
                                </div>
                                <div className="col-md-3 custom-col">
                                    <p>{"Total Records: "+this.state.totalCount}</p>
                                </div>
                            </div>
                        </div>
                        {isEmptyArray(this.state.frameworks) &&
                            <div class="no-items-layout">
                                <div class="no-items-card">
                                    <h6>
                                        {Constants.NO_FRAMEWORKS_FOUND}
                                    </h6>
                                </div>
                            </div>
                        }
                    </div>
                </Modal>
                <AlertDialog 
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                    themeSettings={themeSettings}
                />

                <FrameworkClauseLinkDialog
                    showLinkDialog={this.state.showLinkDialog}
                    handleLinkDialogClose={this.handleLinkDialogClose}
                    rootFrameworkId={this.state.rootFrameworkId}
                    frameworkName={this.state.frameworkName}
                    frameworkId1={this.props.frameworkId1}
                    frameworkClauseId1={this.props.frameworkClauseId1}
                    themeSettings={themeSettings}
                />
            </>
        )
    }
}

export default RootFrameworkDialog;
